export const distinctStringValues = (tab: any[]) =>
  tab.filter((elmt, i, array) => array.indexOf(elmt) === i);

export const CollaboratorsArrayParse = (value: any[]) => {
  if (!value) return [];

  return value.map((elt) => {
    const user = elt.user ?? elt;

    // if already parsed
    if (user.full_name) return elt;

    return { '@id': user.idIri, full_name: `${user.first_name} ${user.last_name}` };
  });
};

export const dateFormat = (date: string) => {
  return !date ? '' : new Intl.DateTimeFormat('fr-FR').format(new Date(date));
};

export const euroFormat = (value: number, decimal?: boolean): string => {
  return !value
    ? '-'
    : new Intl.NumberFormat('fr-FR', {
        style: decimal ? 'decimal' : 'currency',
        currency: 'EUR',
      }).format(value);
};

interface ISpaceNumberFormatProps {
  value: number;
  decimal?: boolean;
  withEuro?: boolean;
  maximumFractionDigits?: number;
}
export const spaceNumberFormat = ({
  value,
  decimal = false,
  withEuro = false,
  maximumFractionDigits = 0,
}: ISpaceNumberFormatProps): string => {
  const options: Intl.NumberFormatOptions = {
    maximumFractionDigits,
  };

  if (decimal) {
    options.style = 'decimal';
  } else if (withEuro) {
    options.style = 'currency';
    options.currency = 'EUR';
  } else {
    options.style = 'decimal';
  }

  return new Intl.NumberFormat('fr-FR', options).format(value);
};

export function spaceNumberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export const twoNumberDigitDisplay = (data: any) =>
  data.toLocaleString('fr-FR', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

export async function convertImageToBase64(imgUrl: string): Promise<string | null> {
  if (!imgUrl) return null;

  try {
    const response = await fetch(
      `https://images.weserv.nl/?url=${encodeURIComponent(imgUrl)}`,
    );
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result as string;
        // if not an image, reuturn null
        resolve(!base64Data.includes('data:image') ? null : base64Data);
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    // console.error("Erreur lors de la conversion de l'image en base64:", error);
    return null;
    // return '';
  }
}
